module.exports = __webpack_public_path__ + "static/media/ic-actions-new-window.c496cfe4.svg";